/**
 * socialLinkOverrides.ts
 *
 * File-level:
 * - Client social link'leri için geçici/merkezi override haritasını içerir.
 * - Bu dosya ClientWorkDetails gibi bileşenlerde orijinal clientsData içeriğini
 *   değiştirmeden belirli client sosyal linklerini güncellemek için kullanılır.
 *
 * Not:
 * - Her giriş client.id ile eşleşir (ör. 'eti', 'duru', 'evy-baby' ...).
 * - Eksik alanlar undefined bırakılabilir; merge sırasında yalnızca verilen alanlar override edilir.
 */

/**
 * ClientSocialLinks
 *
 * Interface-level:
 * - clientsData.ts içerisindeki ClientSocialLinks ile uyumlu bir yapı bekler.
 */
import type { ClientSocialLinks } from './clientsData'

/**
 * socialLinkOverrides
 *
 * - Client ID'lerine göre sağlanan güncellenmiş sosyal medya linklerini tutar.
 * - Kullanım: merged = { ...client.socialLinks, ...(socialLinkOverrides[client.id] ?? {}) }
 */
export const socialLinkOverrides: Record<string, ClientSocialLinks> = {
  'eti': {
    facebook: 'https://www.facebook.com/etiiraq/',
    instagram: 'https://www.instagram.com/eti_iraq/',
    youtube: 'https://www.youtube.com/@Eti_iraq'
  },
  'duru': {
    facebook: 'https://www.facebook.com/DuruIraq',
    instagram: 'https://www.instagram.com/duruiraq/',
    youtube: 'https://www.youtube.com/@duruiraq'
  },
  'evy-baby': {
    facebook: 'https://www.facebook.com/EvyBabyIraq',
    instagram: 'https://www.instagram.com/evybabyiraq/',
    youtube: 'https://www.youtube.com/@evybabyiraq'
  },
  'selpak': {
    facebook: 'https://www.facebook.com/profile.php?id=100090177247234',
    instagram: 'https://www.instagram.com/selpakiraq/',
    youtube: 'https://www.youtube.com/@SelpakTr'
  },
  'onlem': {
    facebook: 'https://www.facebook.com/onlem.iraq',
    instagram: 'https://www.instagram.com/onlem_babycareiraq/'
    // youtube intentionally left undefined
  },
  'talabat': {
    facebook: 'https://www.facebook.com/talabatIraq/',
    instagram: 'https://www.instagram.com/talabat_iq/',
    youtube: 'https://www.youtube.com/watch?v=IcTKZ_xtEic'
  },
  'upcare-hair2000': {
    facebook: 'https://www.facebook.com/upcarehaircare',
    instagram: 'https://www.instagram.com/upcarehaircare/',
    youtube: 'https://www.youtube.com/@upcarehaircare'
  },
  'istikbal': {
    facebook: 'https://www.facebook.com/istikbaliraq',
    instagram: 'https://www.instagram.com/istikbaliraq/',
    youtube: 'https://www.youtube.com/@istikbaliraq6863'
  },
  'bellona': {
    facebook: 'https://www.facebook.com/Bellonairaq',
    instagram: 'https://www.instagram.com/bellonairaq/',
    youtube: 'https://www.youtube.com/@bellonairaq'
  },
  'defacto': {
    // facebook omitted intentionally
    instagram: 'https://www.instagram.com/defacto.global/'
  },
  'tat': {
    facebook: 'https://www.facebook.com/TatIraqOfficial',
    instagram: 'https://www.instagram.com/tat_middleeast/',
    youtube: 'https://www.youtube.com/@tatinternational'
  },
  'ona': {
    facebook: 'https://www.facebook.com/profile.php?id=61557359621419',
    instagram: 'https://www.instagram.com/onairaqofficial/'
    // youtube omitted intentionally
  },
  'magenta': {
    facebook: 'https://www.facebook.com/profile.php?id=100093981225580',
    instagram: 'https://www.instagram.com/you_and_your_conscience/',
    youtube: 'https://www.youtube.com/@YouandYourConscience'
  },
  'emotion': {
    facebook: 'https://www.facebook.com/profile.php?id=61556873282727',
    instagram: 'https://www.instagram.com/emotioniraq/',
    youtube: 'https://www.youtube.com/@emotioniraq'
  }
} as const

export type SocialLinkOverrides = typeof socialLinkOverrides